import { call, get } from 'vuex-pathify';

import { MVT } from 'ol/format';
import { VectorTile as VectorTileLayer } from 'ol/layer';
import { VectorTile as VectorTileSource } from 'ol/source';

import { defaultMvtSourceLoader } from '@/assets/js/mapUtils';

export default {
  computed: {
    failuresDataSource: get('admin/modulesMapping@failures.datasource_name'),
    failuresLayerId: get('admin/modulesMapping@failures.layer_id'),
    failuresLayer: get('layers/featuresLayers@:failuresLayerId'),
    failuresFeatures: get('layers/layersFeatures@:failuresLayerId'),
    layersFilters: get('layers/layersFilters'),
  },
  methods: {
    getLayerFeatures: call('layers/getLayerFeatures'),
    getFeaturesLayer: call('layers/getFeaturesLayer'),
    setCurrentStyle: call('styles/setCurrentStyle'),
    setDefaultStyle: call('styles/setDefaultStyle'),
    setLoaded: call('modules/setLoaded'),
    async toggleFailures(value) {
      if (value) {
        await Promise.all([
          this.getFeaturesLayer(this.failuresLayerId),
          this.getLayerFeatures({ layer_id: this.failuresLayerId }),
        ]);
        this.addFailuresLayer();
        this.toggleModuleIdentification({ isActive: true, moduleRoute: 'failure' });
      } else {
        this.toggleModuleIdentification({ isActive: false, moduleRoute: '' });
        this.removeProjectLayers([this.failuresLayerId]);
        if (this.layersFilters[this.failuresLayerId]) {
          delete this.layersFilters[this.failuresLayerId];
        }
        this.setLoaded({ dataSource: this.failuresDataSource, value: false });
      }
    },
    toggleFailuresFilter() {
      this.removeProjectLayers([this.failuresLayerId]);
      this.addFailuresLayer();
    },
    addFailuresLayer() {
      this.removeProjectLayers([this.failuresLayerId]);
      const { data_source_name, id, type, group_id, name } = this.failuresLayer;
      const style = JSON.parse(JSON.stringify(this.failuresLayer.style_web));

      this.mvtVisibleLayersCounter++;
      const mvtLayer = new VectorTileLayer({
        opacity: 1,
        data_source_name,
        id,
        type,
        group_id,
        name,
        isSpecial: true,
        visible: true,
        source: new VectorTileSource({
          format: new MVT(),
          url: `${process.env.VUE_APP_API_URL}/layers/features_layers/${id}/mvt/{z}/{x}/{y}`,
          projection: this.$_config.defaultEpsg,
          tileLoadFunction: tile => {
            defaultMvtSourceLoader(tile, id, {
              filters: this.layersFilters[this.failuresLayer.id]
                ? this.layersFilters[this.failuresLayer.id].filterExpression
                : {},
            });
          },
        }),
        zIndex: 100,
        style: f => this.getFeatureStyle(f, style, this.failuresLayer.geometry_type, true, id),
        renderMode: 'image',
      });
      const defaultStyle = {
        datasource: this.failuresDataSource,
        name: this.$i18n.t('default.defaultStyle'),
        isDefault: true,
        style: style,
      };
      this.setCurrentStyle({ dataSource: this.failuresDataSource, style: defaultStyle });
      this.setDefaultStyle({ dataSource: this.failuresDataSource, style: defaultStyle });
      mvtLayer.getSource().once('tileloadend', () => {
        ++this.mvtVisibleLayersLoaded;
        this.identifyCoordinatesOnInit();
      });
      this.getLayerById('layers')
        .getLayers()
        .push(mvtLayer);
      this.setLoaded({ dataSource: this.failuresDataSource, value: true });
    },
    async setFailuresStyle(style) {
      const { id, geometry_type } = this.failuresLayer;
      const layersArray = this.getLayerById('layers')
        .getLayers()
        .getArray();
      const layer = layersArray.find(layer => layer.get('id') === this.failuresLayerId);
      layer.setStyle(f => this.getFeatureStyle(f, style.style, geometry_type, false, id));
    },
  },
  mounted() {
    this.$root.$on('failuresStyleChanged', this.setFailuresStyle);
  },
};
